import Lenis from 'lenis';

const initHeaderMenu = ({lenis}: {lenis: Lenis}) => {
    const $el = document.querySelector<HTMLDialogElement>('#js_header_menu');
    const $triggers = document.querySelectorAll<HTMLButtonElement>('.js_header_menuTrigger');
    if(!$el || !$triggers) return;
    $triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        $el.showModal();
        lenis.stop();
      });
    });
  
    const $closeButton = document.querySelector<HTMLButtonElement>('.js_header_menu_headClose');
    if(!$closeButton) return;
    $closeButton.addEventListener('click', () => {
      $el.close();
      lenis.start();
    });

    const $closeTriggers = document.querySelectorAll<HTMLAnchorElement>('[data-close-trigger]');
    if(!$closeTriggers) return;
    $closeTriggers.forEach(closeTrigger => {
      closeTrigger.addEventListener('click', () => {
        $el.close();
        lenis.start();
      });
    });
    
    lenis.on('scroll', (e) => {
      const scrollY = e.animatedScroll;
      const direction = e.direction;
      
      if(scrollY > 100) {
        document.querySelector<HTMLElement>('#js_header')?.classList.add('is-scrolled');

        if(direction === 1) {
          document.querySelector<HTMLElement>('#js_header')?.classList.add('is-scrolled');
        } 
        else {
          document.querySelector<HTMLElement>('#js_header')?.classList.remove('is-scrolled');
        }
      }
      else {
        document.querySelector<HTMLElement>('#js_header')?.classList.remove('is-scrolled');
      }      
    });
};

export default initHeaderMenu;